export default __webpack_public_path__ + "static/media/table-adjusted-work.1a8d6dc2.svg";